<template>

</template>

<script>
  import * as d3 from 'd3'
  export default {
    name: 'D3CollisionWidget',
    mounted () {
      var w = 1280 / 2
      var h = 800 / 1.5

      var nodes = d3.range(200).map(function () {
        return {
          radius: Math.random() * 12 + 4
        }
      })
      // var color = d3.scale.category10()

      var force = d3.layout.force()
        .gravity(0.05)
        .charge(function (d, i) {
          return i ? 0 : -2000
        })
        .nodes(nodes)
        .size([w, h])

      var root = nodes[0]
      root.radius = 0
      root.fixed = true

      force.start()

      const svg = d3.select(this.$el).append('svg:svg')
        .attr('width', w)
        .attr('height', h)

      svg.selectAll('circle')
        .data(nodes.slice(1))
        .enter().append('svg:circle')
        .attr('r', function (d) {
          return d.radius - 2
        })
        .style('fill', function (d, i) {
          var returnColor

          if (i % 3 === 0) {
            returnColor = '#5bc0de'
          } else if (i % 3 === 1) {
            returnColor = '5cb85c'
          } else {
            returnColor = 'eea236'
          }

          return returnColor
        })

      force.on('tick', function (e) {
        var q = d3.geom.quadtree(nodes)
        var i = 0
        var n = nodes.length

        while (++i < n) {
          q.visit(collide(nodes[i]))
        }

        svg.selectAll('circle')
          .attr('cx', function (d) {
            return d.x
          })
          .attr('cy', function (d) {
            return d.y
          })
      })

      svg.on('mousemove', function () {
        var p1 = d3.mouse(this)
        root.px = p1[0]
        root.py = p1[1]
        force.resume()
      })

      function collide (node) {
        var r = node.radius + 16
        var nx1 = node.x - r
        var nx2 = node.x + r
        var ny1 = node.y - r
        var ny2 = node.y + r
        return function (quad, x1, y1, x2, y2) {
          if (quad.point && (quad.point !== node)) {
            var x = node.x - quad.point.x
            var y = node.y - quad.point.y
            var l = Math.sqrt(x * x + y * y)
            var r = node.radius + quad.point.radius
            if (l < r) {
              l = (l - r) / l * 0.5
              node.x -= x *= l
              node.y -= y *= l
              quad.point.x += x
              quad.point.y += y
            }
          }
          return x1 > nx2 ||
            x2 < nx1 ||
            y1 > ny2 ||
            y2 < ny1
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/widgets/D3-Collision-Widget.vue